<h2 mat-dialog-title>Approve commercial</h2>
<mat-dialog-content>
  <p class="muted">Enter a name for this recording and confirm the station.</p>
  <mat-form-field appearance="outline" floatLabel="always" class="full-width" subscriptSizing="dynamic">
    <mat-label>Recording name</mat-label>
    <input matInput [(ngModel)]="recordingName" name="recordingName" placeholder="e.g. Spring Sale 30s" />
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always" class="full-width" subscriptSizing="dynamic">
    <mat-label>Station</mat-label>
    <input matInput [(ngModel)]="stationName" name="stationName" readonly disabled />
  </mat-form-field>
  <div class="product-type-field" [class.has-error]="productTypeError">
    <app-product-type-selector
      label="Assign Product Types *"
      [preselectedIds]="preselectedProductTypeIds"
      [hideInputWhenSelected]="true"
      (selectionChange)="onProductTypesChange($event)">
    </app-product-type-selector>
    @if (productTypeError) {
      <p class="field-error" role="alert">{{ productTypeError }}</p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    class="approve-submit-btn"
    (click)="submit()"
    [disabled]="!recordingName.trim() || selectedProductTypeIds.length === 0 || sending">
    <span class="approve-submit-btn__content">
      @if (sending) {
        <mat-spinner diameter="20" class="approve-submit-spinner" />
        <span>Approving…</span>
      } @else {
        <span>Approve</span>
      }
    </span>
  </button>
</mat-dialog-actions>
